var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Files-Folders / Folder / Black Filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Files-Folders-/-Folder-/-Black-Filled",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 3.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.75,5.48076923 C20.75,4.60985866 20.0439875,3.90384615 19.1730769,3.90384615 L8.92307692,3.90384615 L7.03076923,1.38076923 C6.7329604,0.983690787 6.26557882,0.75 5.76923077,0.75 L1.82692308,0.75 C0.95601251,0.75 0.25,1.45601251 0.25,2.32692308 L0.25,16.5192308 C0.25,17.3901413 0.95601251,18.0961538 1.82692308,18.0961538 L19.1730769,18.0961538 C20.0439875,18.0961538 20.75,17.3901413 20.75,16.5192308 L20.75,5.48076923 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 1.5,
    fillOpacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.47265106 4.38431924 0.637952515 4.38431924 0.637952515 0.75 6.23064161 0.75"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBlack);
export default __webpack_public_path__ + "static/media/folder-black.0bd46559a441ae90cca48da4a6ca8a48.svg";
export { ForwardRef as ReactComponent };